__turbopack_context__.v({
  "bottomMetaArea": "Footer-module__Grjkva__bottomMetaArea",
  "brandBlock": "Footer-module__Grjkva__brandBlock",
  "copyright": "Footer-module__Grjkva__copyright",
  "divider": "Footer-module__Grjkva__divider",
  "footerWrapper": "Footer-module__Grjkva__footerWrapper",
  "iconSquare": "Footer-module__Grjkva__iconSquare",
  "legalLink": "Footer-module__Grjkva__legalLink",
  "legalPipe": "Footer-module__Grjkva__legalPipe",
  "legalRow": "Footer-module__Grjkva__legalRow",
  "logoHeading": "Footer-module__Grjkva__logoHeading",
  "logoSquare": "Footer-module__Grjkva__logoSquare",
  "navLink": "Footer-module__Grjkva__navLink",
  "navLinksRow": "Footer-module__Grjkva__navLinksRow",
  "socialRow": "Footer-module__Grjkva__socialRow",
  "subTagItem": "Footer-module__Grjkva__subTagItem",
  "subTagsRow": "Footer-module__Grjkva__subTagsRow",
  "watermark": "Footer-module__Grjkva__watermark",
});
